import axios from '../utils/axios';
import Constants from './types';
import { getSessionId, getEntityById, getPayloadFromError } from 'src/utils';

export const getDataProfiles = () => {
  const sessionId = getSessionId();
  return dispatch => {
    dispatch(getDataProfilesRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/data-profiles',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(getDataProfilesSuccess(transformDataProfiles(res.data)));
      })
      .catch(err => {
        dispatch(getDataProfilesFailure(err));
      });
  };
};

export const getDataProfileAttribs = id => {
  const sessionId = getSessionId();
  return dispatch => {
    dispatch(getDataProfileAttribsRequest());
    axios({
      method: 'get',
      url: `/openempi-ws-rest/1.0/data-profiles/${id}/attributes`,
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(getDataProfileAttribsSuccess(res.data));
      })
      .catch(err => {
        dispatch(getDataProfileAttribsFailure(err));
      });
  };
};

export const getDataProfileAttribValues = (dataProfileId, attributeId) => {
  const sessionId = getSessionId();
  return dispatch => {
    dispatch(getDataProfileAttribValuesRequest());
    axios({
      method: 'get',
      url: `/openempi-ws-rest/1.0/data-profiles/${dataProfileId}/attributes/${attributeId}/values`,
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(getDataProfileAttribValuesSuccess(res.data));
      })
      .catch(err => {
        dispatch(getDataProfileAttribValuesFailure(err));
      });
  };
};

export const deleteDataProfile = dataProfileId => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'DELETE',
      url: '/openempi-ws-rest/1.0/data-profiles/' + dataProfileId,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(deleteDataProfileSuccess(res.data));
        dispatch(getDataProfiles());
      })
      .catch(err => {
        dispatch(deleteDataProfileFailure(err));
      });
  };
};

export const generateDataProfile = entityId => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'POST',
      url: '/openempi-ws-rest/1.0/data-profiles',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: { entityId }
    })
      .then(res => {
        dispatch(generateDataProfileSuccess(res.data));
      })
      .catch(err => {
        dispatch(generateDataProfileFailure(err));
      });
  };
};

export const clearDataProfilesError = () => {
  return {
    type: Constants.DATAPROFILE_CLEAR_ERROR
  };
};

const transformDataProfiles = profiles => {
  const newProfiles = profiles.map(profile => transformDataProfile(profile));
  return newProfiles;
};

const transformDataProfile = profile => {
  // if (link.userCreatedBy && mapUserById[link.userCreatedBy]) {
  //   link.userCreatedBy = mapUserById[link.userCreatedBy].username;
  // }
  const entity = getEntityById(profile.entityId);
  profile.entity = entity ? entity.displayName : 'Unknown';
  profile.source =
    profile.dataSourceId === -1
      ? 'Repository'
      : `User File ${profile.dataSourceId}`;
  return profile;
};

const getDataProfilesRequest = () => {
  return {
    type: Constants.DATAPROFILE_GET_REQUEST
  };
};

const getDataProfilesSuccess = data => {
  return {
    type: Constants.DATAPROFILE_GET_SUCCESS,
    payload: data
  };
};

const getDataProfilesFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.DATAPROFILE_GET_FAILURE,
    payload
  };
};

const deleteDataProfileSuccess = data => {
  return {
    type: Constants.DATAPROFILE_DELETE_SUCCESS,
    payload: data
  };
};

const deleteDataProfileFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.DATAPROFILE_DELETE_FAILURE,
    payload
  };
};

const generateDataProfileSuccess = data => {
  return {
    type: Constants.DATAPROFILE_GENERATE_SUCCESS,
    payload: data
  };
};

const generateDataProfileFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.DATAPROFILE_GENERATE_FAILURE,
    payload
  };
};

const getDataProfileAttribsRequest = () => {
  return {
    type: Constants.DATAPROFILE_GETATTR_REQUEST
  };
};

const getDataProfileAttribsSuccess = data => {
  return {
    type: Constants.DATAPROFILE_GETATTR_SUCCESS,
    payload: data
  };
};

const getDataProfileAttribsFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.DATAPROFILE_GETATTR_FAILURE,
    payload
  };
};

const getDataProfileAttribValuesRequest = () => {
  return {
    type: Constants.DATAPROFILE_GETATTRVAL_REQUEST
  };
};

const getDataProfileAttribValuesSuccess = data => {
  return {
    type: Constants.DATAPROFILE_GETATTRVAL_SUCCESS,
    payload: data
  };
};

const getDataProfileAttribValuesFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.DATAPROFILE_GETATTRVAL_FAILURE,
    payload
  };
};
